import {FC} from 'react'
import clsx from 'clsx'
import {WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import { QKTSVG } from '../../../../helpers/components/QKTSVG'
import { useTableros } from '../../../../../Hooks/useTableros'
import { IArea } from '../../../../../types/Areas'

type Props = {
  title: string
  areaId?: IArea["areaId"]
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const QSidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  title,
  areaId,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const {config} = useLayout()
  const {app} = config
  const {filtrarTablerosPorArea} = useTableros()

  return (
    <div className='menu-item' role='button' onClick={() => filtrarTablerosPorArea(areaId)}>
      {hasBullet && (
        <span className='menu-bullet'>
          <span className='bullet bullet-dot'></span>
        </span>
      )}
      {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
        <span className='menu-icon'>
          {' '}
          <QKTSVG url={icon} className='menu-svg-icon' />
        </span>
      )}
      {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
        <i className={clsx('bi fs-3', fontIcon)}></i>
      )}
      <span className='menu-title'>{title}</span>
      {children}
    </div>
  )
}

export {QSidebarMenuItem}
